import { get, put, post, del } from "./base";

// 获取统计
export function getStatistics(){
    return get("/api/live/statistics")
}

// 获取直播流列表
export function getList(data){
    return get("/api/stream/list",data)
}

// 新增  /api/generate/LiveUrl
export function postLiveUrl(data){
    return post("/api/generate/LiveUrl",data)
}

// 修改
export function getRecord(streamId){
    return get("/api/stream/record?streamId="+streamId)
}


// 修改
export function putLiveUrl(data){
    return put("/api/live/stream",data)
}

// 观看设置
export function putWatchDetail(data){
    return put("/api/live/watch/detail",data)
}
